import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { getServiceUrl, getAuthKey, siteHost } from '../CONFIG';
import { loadCaptchaEnginge, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';
import { sha512 } from 'js-sha512';
import ErrorPopupNotification from '../Shared/ErrorPopupNotification';
import { postDataWithNodeServiceApi } from '../Utils/SQLUtils'
import CreateLoginDetailsCookie from './LoginCookies';
import ReactHtmlParser from 'react-html-parser'

let _hostType = localStorage.mode;
let _siteHost = getServiceUrl();
var siteUrl = siteHost(_hostType)
var AuthKey = getAuthKey();

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const Login = ({ reloadOnError }) => {

    const [loginFormData, setLoginFormData] = useState({
        'email': '',
        'password': '',
        'captchaText': ''
    })
    //const [email, setEmail] = useState("");
    //const [password, setPassword] = useState("");
    //const [captchaText, setCaptchaText] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [openErrorDialog, setopenErrorDialog] = useState(false);


    useEffect(() => {
        loadCaptchaEnginge(6, 'white', 'blue', 'upper');
    }, [])

    const onLogin = (event) => {
        event.preventDefault();
        if (!loginFormData.email || !loginFormData.password) {
            showValidationMessage('Invalid Login Credentials',"captchaText")
        } else if (!emailRegex.test(loginFormData.email)) {
            showValidationMessage('Invalid Login Credentials', "email")
        } else if (validateCaptcha(loginFormData.captchaText.toUpperCase()) == false) {
            showValidationMessage('Captcha is not valid', "captchaText")
        }
        else {
            getUserInfo();
        }
    }

    const showValidationMessage = (message, element) => {
        setErrorMessage(message);
        setopenErrorDialog(true);
        setLoginFormData((prev) => ({
            ...prev,
            "password": "",
            [element]: ""
        }))
    }

    const validateLoginDetails = (detail) => {
        try {
            let currentDate = new Date();
            let dateLoginAttempt = detail.LoginAttemptDateUtc == null ? currentDate.toISOString() : detail.LoginAttemptDateUtc;
            let utctime = new Date(currentDate.getUTCFullYear(), currentDate.getUTCMonth(), currentDate.getUTCDate(), currentDate.getUTCHours(), currentDate.getUTCMinutes(), currentDate.getUTCSeconds());
            let loginAttemptDate = new Date(dateLoginAttempt.substring(0, dateLoginAttempt.indexOf('.')));
            let diffInMinutes = ((utctime - loginAttemptDate) / (1000 * 60))
            if (detail.IsActive == false) {
                setErrorMessage('User is Inactive');
                setopenErrorDialog(true);
            }
            else if (diffInMinutes <= 0 && detail.LoginAttempts > 2) {
                addLoginAttempts();
                setErrorMessage('User is Blocked for 30 minutes');
                setopenErrorDialog(true);
            }
            else {
                CreateLoginDetailsCookie(AuthKey, JSON.stringify(detail)).then(result => {
                    if (result) {
                        window.location.href = '/Dashboard/Index';
                    } else {
                        console.error('CreateLoginDetailsCookie failed ', result);
                    }
                });
            }
        } catch (err) {
            console.error('Error in validateLoginDetails: ', err);
        }
    }

    const getUserInfo = () => {
        localStorage.setItem("mode", mode);
        let url = "callprocedurewithparam/USP_GetUserInfo"
        let params = { 'EmailId': loginFormData.email, 'Password': sha512(loginFormData.password) }

        postDataWithNodeServiceApi(url, params, (json) => {
            if (json !== undefined) {
                if (json.recordsets !== undefined && json.recordsets.length > 0) {
                    if (json.recordsets[0] !== undefined && json.recordsets[0].length > 0) {
                        const loginDetails = json.recordsets[0][0];
                        console.log(loginDetails)
                        validateLoginDetails(loginDetails);
                    }
                    else {
                        addLoginAttempts();
                        setErrorMessage('Invalid Login Credentials');
                        setopenErrorDialog(true);
                    }
                }
                else {
                    addLoginAttempts();
                    setErrorMessage('Invalid Login Credentials');
                    setopenErrorDialog(true);
                }
            }
        })
    }

    const closeErrorPopup = () => {
        setopenErrorDialog(false);
        //reloadOnError(true);
    }

    const addLoginAttempts = () => {
        let url = "callprocedurewithparam/USP_AddLoginAttempts"
        let params = { 'EmailId': loginFormData.email }
        postDataWithNodeServiceApi(url, params, (json) => {
            if (json !== undefined) {
                if (json.recordsets !== undefined && json.recordsets.length > 0) {
                    if (json.recordsets[0] !== undefined && json.recordsets[0].length > 0) {
                        if (json.recordsets[0][0] != "") {
                            return json.recordsets[0][0]
                        }
                    }
                }
            }
        })
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setLoginFormData((prev) => ({
            ...prev,
            [name]: name === 'captchaText' ? value.toUpperCase() : value,
        }));
    }

    return (
        <div className="login-container-div">
            <div className="login-form-header">
                {/*<span>Welcome to</span>*/}
                {/*<img src="/images/UIImages/unimart-logo.png" />*/}
                Use a local account to log in.
            </div>

            <div className="login-main-section">
                <form onSubmit={onLogin}>
                    <div className="login-form-div">
                        <div className="login-control-div">
                            <label>E-mail id</label>
                            <input type="text"
                                name="email"
                                value={loginFormData.email}
                                    onChange={(e) => handleChange(e)} />
                        </div>
                        <div className="login-control-div">
                            <label>Password</label>
                            <input type="password"
                                name="password"
                                value={loginFormData.password}
                                onChange={(e) => handleChange(e)}
                                    style={{ "color": "black" }} />
                        </div>

                        
                        <div className="login-control-div captcha">
                        <label>Captcha</label>
                            <input type="text"
                                name="captchaText"
                                value={loginFormData.captchaText}
                                onChange={(e) => handleChange(e)} />
                            <div className="login-captcha-div">
                                <div className="login-captcha-refresh"><ReloadCaptcha /></div>
                                <LoadCanvasTemplateNoReload />
                            </div>
                        </div>
                        
                        <div className="login-form-submit-div">
                            <button type="submit" className="login-form-submit-btn">Log In</button>
                            <a href="/Login/ForgotPassword" className="forget-pass-lbl">Forgot Password?</a>
                        </div>
                    </div>
                </form>
            </div>
            <ErrorPopupNotification open={openErrorDialog} message={errorMessage}
                handleClose={() => closeErrorPopup()} />
        </div>
    );
}

const ReloadCaptcha = () => {

    return <i className='fa fa-refresh' aria-hidden='true'
        onClick={() => loadCaptchaEnginge(6, 'white', 'blue', 'upper')}>
    </i >

}

export default function App() {
    const [key, setKey] = useState(0); // This key will force component reload
    const [error, setError] = useState(null);

    const reloadOnError = (err) => {
        //setTimeout(() => {
        //    // Auto-retry after 2 seconds
        //    setKey(prev => prev + 1);
        //    setError(null);
        //}, 2000);
        setKey(prev => prev + 1);
    }
    return (
        <div style={{ padding: '20px', fontFamily: 'Arial' }}>
            {error && <p style={{ color: 'red' }}>Error: {error.message} – Retrying...</p>}
            <Login key={key} reloadOnError={reloadOnError} />
        </div>
    )
};
var mode = document.getElementById("hdnMode").value;
ReactDOM.render(<App />, document.getElementById("reactLoginDIV"));